// extracted by mini-css-extract-plugin
export default {"selectRow":"CashDeposits_selectRow__zBjqp","row":"CashDeposits_row__eJu8q","select":"CashDeposits_select__23bOF","loader":"CashDeposits_loader__xXtCz"};